<template>
  <!--blog with left slide -->
  <div class="page-margin">
    <!--breadcrumb start-->
    <div class="breadcrumb-bg">
      <div class="container">
        <div class="row">
          <div class="col-md-6 col-sm-6 d-align-center">
            <h2 class="title"><span> Blog</span></h2>
          </div>
          <div class="col-md-6 col-sm-6">
            <nav aria-label="breadcrumb" class="theme-breadcrumb">
              <ol class="breadcrumb bg-transparent mb-0">
                <li class="breadcrumb-item">
                  <router-link :to="{ name: 'Index' }">Home</router-link>
                </li>
                <li class="breadcrumb-item active">
                  <a href="#">Bloglist with sidebar</a>
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
    </div>
    <!--breadcrumb end -->

    <!-- blog Section start -->
    <section class="blog-page">
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-lg-9 blog-sec">
            <div class="row blog-list">
              <div class="col-lg-6 col-md-12">
                <div class="item news-slid">
                  <router-link target="_blank" :to="{ name: 'Blogdetails' }">
                    <div class="news-box">
                      <img
                        src="../assets/images/blog/1.jpg"
                        alt="news-1"
                        class="img-fluid"
                      />
                    </div>
                  </router-link>
                  <div class="news-text">
                    <div class="blog-hover">
                      <h4>lorem ipsum dolor sit amet</h4>
                      <ul class="list-inline blog-details-list">
                        <li><a href="#">John Doe</a></li>
                        <li><a href="#">1 Oct</a></li>
                        <li><a href="#">25 comments</a></li>
                        <li><a href="#">3 View</a></li>
                      </ul>
                    </div>
                    <p>
                      lorem ipsum dolor sit amet, consecteturamet adipisicing
                      elit, tempor incididunt ut labore. lorem ipsum dolor sit
                      amet.
                    </p>
                    <router-link :to="{ name: 'Blogdetails' }"
                      ><div class="btn-theme">View more</div></router-link
                    >
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-md-12">
                <div class="item news-slid">
                  <router-link target="_blank" :to="{ name: 'Blogdetails' }">
                    <div class="news-box">
                      <img
                        src="../assets/images/blog/2.jpg"
                        alt="news-1"
                        class="img-fluid"
                      />
                    </div>
                  </router-link>
                  <div class="news-text">
                    <div class="blog-hover">
                      <h4>lorem ipsum dolor sit amet</h4>
                      <ul class="list-inline blog-details-list">
                        <li><a href="#">John Doe</a></li>
                        <li><a href="#">2 Oct</a></li>
                        <li><a href="#">25 comments</a></li>
                        <li><a href="#">3 View</a></li>
                      </ul>
                    </div>
                    <p>
                      lorem ipsum dolor sit amet, consecteturamet adipisicing
                      elit, tempor incididunt ut labore. lorem ipsum dolor sit
                      amet.
                    </p>
                    <div class="btn-theme">View more</div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-md-12">
                <div class="item news-slid">
                  <router-link target="_blank" :to="{ name: 'Blogdetails' }">
                    <div class="news-box">
                      <img
                        src="../assets/images/blog/3.jpg"
                        alt="news-1"
                        class="img-fluid"
                      />
                    </div>
                  </router-link>
                  <div class="news-text">
                    <div class="blog-hover">
                      <h4>lorem ipsum dolor sit amet</h4>
                      <ul class="list-inline blog-details-list">
                        <li><a href="#">John Doe</a></li>
                        <li><a href="#">3 Oct</a></li>
                        <li><a href="#">25 comments</a></li>
                        <li><a href="#">3 View</a></li>
                      </ul>
                    </div>
                    <p>
                      lorem ipsum dolor sit amet, consecteturamet adipisicing
                      elit, tempor incididunt ut labore. lorem ipsum dolor sit
                      amet.
                    </p>
                    <div class="btn-theme">View more</div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-md-12">
                <div class="item news-slid">
                  <router-link target="_blank" :to="{ name: 'Blogdetails' }">
                    <div class="news-box">
                      <img
                        src="../assets/images/blog/4.jpg"
                        alt="news-1"
                        class="img-fluid"
                      />
                    </div>
                  </router-link>
                  <div class="news-text">
                    <div class="blog-hover">
                      <h4>lorem ipsum dolor sit amet</h4>
                      <ul class="list-inline blog-details-list">
                        <li><a href="#">John Doe</a></li>
                        <li><a href="#">41 Oct</a></li>
                        <li><a href="#">25 comments</a></li>
                        <li><a href="#">3 View</a></li>
                      </ul>
                    </div>
                    <p>
                      lorem ipsum dolor sit amet, consecteturamet adipisicing
                      elit, tempor incididunt ut labore. lorem ipsum dolor sit
                      amet.
                    </p>
                    <div class="btn-theme">View more</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- sidebar section -->
          <div class="col-md-4 col-lg-3 order-md-first list-sidebar">
            <div class="sidebar">
              <div class="sidebar-space">
                <h4 class="blog-title">blog Category</h4>
                <div class="blog-divider"></div>
                <div class="blog-cat-detail">
                  <ul>
                    <li class="marg-15">
                      <router-link
                        target="_blank"
                        :to="{ name: 'Blogdetails' }"
                      >
                        <i class="fa fa-angle-right" aria-hidden="true"></i>
                        Lorem Ipsum is simply
                      </router-link>
                    </li>
                    <li class="marg-15">
                      <router-link
                        target="_blank"
                        :to="{ name: 'Blogdetails' }"
                      >
                        <i class="fa fa-angle-right" aria-hidden="true"></i>
                        There Are Many Variations
                      </router-link>
                    </li>
                    <li class="marg-15">
                      <router-link
                        target="_blank"
                        :to="{ name: 'Blogdetails' }"
                      >
                        <i class="fa fa-angle-right" aria-hidden="true"></i> it
                        has survived not five
                      </router-link>
                    </li>
                    <li class="marg-15">
                      <router-link
                        target="_blank"
                        :to="{ name: 'Blogdetails' }"
                      >
                        <i class="fa fa-angle-right" aria-hidden="true"></i>
                        Lorem Ipsum has been the.
                      </router-link>
                    </li>
                    <li class="marg-15">
                      <router-link
                        target="_blank"
                        :to="{ name: 'Blogdetails' }"
                      >
                        <i class="fa fa-angle-right" aria-hidden="true"></i>
                        Lorem Ipsum is random.
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="sidebar-space">
                <h4 class="blog-title">Popular Tag</h4>
                <div class="blog-divider"></div>
                <div class="tags marg-20">
                  <a href="#"
                    ><span class="badge badge-theme">Responsive design</span></a
                  >
                  <a href="#"
                    ><span class="badge badge-theme">Color options</span></a
                  >
                  <a href="#"
                    ><span class="badge badge-theme">Multiple demos</span></a
                  >
                  <a href="#"
                    ><span class="badge badge-theme">Dedicated support</span></a
                  >
                  <a href="#"
                    ><span class="badge badge-theme">Documentation</span></a
                  >
                  <a href="#"
                    ><span class="badge badge-theme">PSD is included</span></a
                  >
                  <a href="#"><span class="badge badge-theme">Text</span></a>
                  <a href="#"><span class="badge badge-theme">Support</span></a>
                  <a href="#"
                    ><span class="badge badge-theme">Responsive</span></a
                  >
                  <a href="#"><span class="badge badge-theme">Design</span></a>
                </div>
              </div>
              <h4 class="blog-title">Recent Post</h4>
              <div class="blog-divider"></div>
              <div class="recent-blog marg-20">
                <div class="media">
                  <img
                    class="mr-3"
                    src="../assets/images/blog/blog-comment-two.jpg"
                    alt="blog"
                  />
                  <div class="media-body">
                    <router-link target="_blank" :to="{ name: 'Blogdetails' }">
                      <h5 class="mt-0">Lorem Ipsum Is Simply Dummy</h5>
                    </router-link>
                    <p class="m-0">05 March 2011</p>
                  </div>
                </div>
                <div class="media">
                  <img
                    class="mr-3"
                    src="../assets/images/blog/blog-comment-three.jpg"
                    alt="blog"
                  />
                  <div class="media-body">
                    <router-link target="_blank" :to="{ name: 'Blogdetails' }">
                      <h5 class="mt-0">Lorem Ipsum Is Simply Dummy</h5>
                    </router-link>
                    <p class="m-0">05 March 2011</p>
                  </div>
                </div>
                <div class="media">
                  <img
                    class="mr-3"
                    src="../assets/images/blog/blog-comment.jpg"
                    alt="blog"
                  />
                  <div class="media-body">
                    <router-link target="_blank" :to="{ name: 'Blogdetails' }">
                      <h5 class="mt-0">Lorem Ipsum Is Simply Dummy</h5>
                    </router-link>
                    <p class="m-0">05 March 2011</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- sidebar section -->
        </div>
      </div>

      <div class="animation-circle absolute">
        <i></i>
        <i></i>
        <i></i>
      </div>
      <div class="animation-circle-inverse">
        <i></i>
        <i></i>
        <i></i>
      </div>
    </section>
    <!-- blog Section End -->

    <!--Footer Section start-->
    <Copyright />
    <!--Footer Section End-->
  </div>
  <!--end blog details-->
</template>
<script>
import Copyright from "@/components/copy_right.vue";

export default {
  name: "Blogdetails",
  components: {
    Copyright,
  },
  beforeCreate: function () {
    document.body.className = "inner-page";
  },
};
</script>
